import React, { useState } from "react";
import style from "./index.module.css";
import openEye from "../../../Assets/openEye.png";
import closedEye from "../../../Assets/closedEye.png";

const RecFirstForm = ({ handleChange, formData }) => {
  const [passwordType, setPasswordType] = useState(false);

  const togglePassword = () => {
    setPasswordType(!passwordType);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };
  return (
    <div>
      <div className={style.iconInput}>
        {/* <img src={mail} alt='emailIcon' /> */}
        <input
          type="text"
          placeholder="First Name"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          className={style.fir}
          autoComplete="off"
          onKeyDown={handleKeyDown}
        />
      </div>
      <div className={style.iconInput}>
        {/* <img src={mail} alt='emailIcon' /> */}
        <input
          type="text"
          placeholder="Last Name"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
          className={style.fir}
          autoComplete="off"
          onKeyDown={handleKeyDown}
        />
      </div>
      <div className={style.iconInput}>
        {/* <img src={mail} alt='emailIcon' /> */}
        <input
          type="text"
          placeholder="Title - Ex. HR"
          name="jobTitle"
          value={formData.jobTitle}
          onChange={handleChange}
          className={style.fir}
          autoComplete="off"
          onKeyDown={handleKeyDown}
        />
      </div>
      <div className={style.iconInput}>
        {/* <img src={mail} alt='emailIcon' /> */}
        <input
          type="email"
          placeholder="Email Address"
          name="email"
          value={formData.email}
          onChange={handleChange}
          autoComplete="off"
          onKeyDown={handleKeyDown}
        />
      </div>
      {/* <img src={PasswordIcon} alt='passwordIcon' /> */}
      <div className={`${style.passwordEyeIcon} ${style.iconInput}`}>
        <input
          type={passwordType ? "text" : "password"}
          name="password"
          placeholder="Create Password"
          value={formData.password}
          onChange={handleChange}
          autoComplete="off"
          onKeyDown={handleKeyDown}
        />
        <img
          src={passwordType ? openEye : closedEye}
          onClick={togglePassword}
          style={{ cursor: "pointer" }}
          alt="eyeIcon"
        />
      </div>
    </div>
  );
};

export default RecFirstForm;
